import { screenSizes } from '@lux/tokens';

export enum Screen {
    mobile,
    smallTablet,
    tablet,
    desktop,
}

/**
 * Minimum screen media query creator EXCLUDING the parameter
 * @param screen Screen enum value
 */
export const screenBiggerThan = (screen: Exclude<Screen, Screen.desktop>): string => {
    if (screen === Screen.mobile) {
        return `@media screen and (min-width: ${screenSizes.xs}px)`;
    }
    if (screen === Screen.smallTablet) {
        return `@media screen and (min-width: ${screenSizes.sm}px)`;
    }
    if (screen === Screen.tablet) {
        return `@media screen and (min-width: ${screenSizes.md}px)`;
    }

    return '';
};

/**
 * Maximum screen media query creator EXCLUDING the parameter
 * @param screen Screen enum value
 */
export const screenSmallerThan = (screen: Exclude<Screen, Screen.mobile>): string => {
    if (screen === Screen.smallTablet) {
        return `@media screen and (max-width: ${screenSizes.xs - 1}px)`;
    }
    if (screen === Screen.tablet) {
        return `@media screen and (max-width: ${screenSizes.sm - 1}px)`;
    }
    if (screen === Screen.desktop) {
        return `@media screen and (max-width: ${screenSizes.md - 1}px)`;
    }

    return '';
};
